import { networkResource } from "resources";

import useResource from "./useResource";

export default () => useResource(networkResource);
